module.exports = __webpack_public_path__ + "static/media/vit.6713dfa6.png";